import { observer } from "mobx-react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

import IntroPerformers from "components/Intro/IntroPerformers/IntroPerformers";
import ServicesSection from "./components/ServicesSection/ServicesSection";
import PlatformsSection from "./components/PlatformsSection/PlatformsSection";
import AboutSection from "./components/AboutSection/AboutSection";
import StatisticsSection from "./components/StatisticsSection/StatisticsSection";
import AdvantagesSection from "./components/AdvantagesSection/AdvantagesSection";

import AppStore from "AppStore";

import { carouselSlides } from "./carouselData";
import { useMatchMedia } from "utils/hooks/use-match-media";

import "./Main.scss";

const Main = observer(({ sponsorId }) => {
  const { isMobile, isTablet } = useMatchMedia();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <main className="main">
      <Helmet>
        <title>Биржа заданий и ПФ экспериментов — Boostclick.ru</title>
        <meta name="description" content="Сервис для накрутки ПФ ЛЮДИ: лайки, подписки, отзывы на досках объявлений, маркетплейсах и поисковых системах от реальных пользователей." />
        <meta name="robots" content={sponsorId ? "noindex" : "all"} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Helmet>

      <section className="main__header">
        <div className="main__header-description">
          <div className="main__header-description-title">
            <h1>Boostclick</h1>
            <p>&nbsp;— платформа пользовательских сценариев {!isMobile && <br />} и ПФ-экспериментов</p>
            <div className="main__header-description-highlighted" />
          </div>
          <p className="main__header-description-text">Вы размещаете сценарий на Boostclick, и сторонние исполнители выполняют задания взаимодействуют с интерфейсом, делятся мнением, оценивают путь пользователя. Все фиксируется через отчет</p>
        </div>
        <IntroPerformers />
      </section>

      <ServicesSection store={AppStore} isMobile={isMobile} />

      <div className="main__container">
        <PlatformsSection store={AppStore} isMobile={isMobile} />
        <AboutSection isMobile={isMobile} />
        <StatisticsSection isMobile={isMobile} isTablet={isTablet} />
        <AdvantagesSection slides={carouselSlides} isMobile={isMobile} />
      </div>

    </main>
  );
});

export default Main;
